import type { ProjectScope } from './project-scope.ts';

const pendingPersonnelProfileDeleteKeys = new Set<string>();

function personnelProfileDeleteKey(scope: ProjectScope, personnelId: string): string {
    return `${scope.orgId}/${scope.projectId}/${personnelId}`;
}

function personnelScopePrefix(scope: ProjectScope): string {
    return `${scope.orgId}/${scope.projectId}/`;
}

function personnelIdFromKey(scope: ProjectScope, key: string): string | null {
    const prefix = personnelScopePrefix(scope);
    return key.startsWith(prefix) ? key.slice(prefix.length) : null;
}

export function markPendingPersonnelProfileDelete(scope: ProjectScope, personnelId: string): void {
    pendingPersonnelProfileDeleteKeys.add(personnelProfileDeleteKey(scope, personnelId));
}

export function isPendingPersonnelProfileDelete(scope: ProjectScope, personnelId: string): boolean {
    return pendingPersonnelProfileDeleteKeys.has(personnelProfileDeleteKey(scope, personnelId));
}

export function clearPendingPersonnelProfileDeletesMissingFromRemote(
    scope: ProjectScope,
    remotePersonnelIds: ReadonlySet<string>
): void {
    for (const key of Array.from(pendingPersonnelProfileDeleteKeys)) {
        const personnelId = personnelIdFromKey(scope, key);
        if (personnelId && !remotePersonnelIds.has(personnelId)) {
            pendingPersonnelProfileDeleteKeys.delete(key);
        }
    }
}

export function clearPendingPersonnelProfileDeletes(): void {
    pendingPersonnelProfileDeleteKeys.clear();
}
